/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyGroupingRuleAggregate {
    getFixupPrototypeFunction() { return CostAnomalyGroupingRuleAggregate.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyGroupingRuleAggregate>): CostAnomalyGroupingRuleAggregate {
        let obj = Object.assign(new CostAnomalyGroupingRuleAggregate(), model);
        CostAnomalyGroupingRuleAggregate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyGroupingRuleAggregate>): CostAnomalyGroupingRuleAggregate {
        if (!model) return null;
        return CostAnomalyGroupingRuleAggregate.newInstance(<CostAnomalyGroupingRuleAggregate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyGroupingRuleAggregate) {
        if (!obj) return;

        models.CostAnomalyGroupingRuleAggregate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyGroupingRuleAggregate): boolean {
        Object.setPrototypeOf(obj, CostAnomalyGroupingRuleAggregate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cost_impact === undefined) {
            this.cost_impact = 0;
        }
        if (this.expected_cost === undefined) {
            this.expected_cost = 0;
        }
        if (this.actual_cost === undefined) {
            this.actual_cost = 0;
        }
        if (this.anomaly_count === undefined) {
            this.anomaly_count = 0;
        }
        if (this.upper_bound === undefined) {
            this.upper_bound = 0;
        }
        if (this.lower_bound === undefined) {
            this.lower_bound = 0;
        }
    }

    /**
     * Aggregate cost impact for the grouping rule
     */
    cost_impact: number;

    /**
     * Expected aggregated cost
     */
    expected_cost: number;

    /**
     * Actual aggregated cost
     */
    actual_cost: number;

    /**
     * Grouping Rule wise anomaly count
     */
    anomaly_count: number;

    /**
     * Aggregate anomaly type for the grouping rule
     */
    anomaly_type: models.CostAnomalyType;

    /**
     * Upper bound for the aggregate (if applicable)
     */
    upper_bound: number;

    /**
     * Lower bound for the aggregate (if applicable)
     */
    lower_bound: number;

}
